<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'},
        { type: 'alert', label: '알림 대상자 선택' },
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>


    <!--    전기 외함-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle: '전기 외함',
      form: {
        inspectionTitle: '전기 외함',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '뒷 커버 등의 볼트 조임과 이완 및 바닥의 이물질 상태',
          is_checked: ''
        },
        {
          id: 2,
          label: '문의 개폐상태',
          is_checked: ''
        },
        {
          id: 3,
          label: '점검창과 패킹 등 열화에 의한 손상상태',
          is_checked: ''
        },
        {
          id: 4,
          label: '볼트류 등의 조임이 여부와 진동 및 소리상태',
          is_checked: ''
        },
        {
          id: 5,
          label: '점검창 등 오손 유무와 내부의 시야상태',
          is_checked: ''
        },
        {
          id: 6,
          label: '조임과 이완 등에 의한 탈거현상과 파손 및 선명도 상태',
          is_checked: ''
        },
        {
          id: 7,
          label: '인출기기의 접촉위치 및 단로위치의 상태',
          is_checked: ''
        },
        {
          id: 8,
          label: '적당한 위치의 정위치 유무',
          is_checked: ''
        },
        {
          id: 9,
          label: '전기 주회로 인입 인출부',
          is_checked: ''
        },
        {
          id: 10,
          label: '볼트류의 조임 유무와 이완 시 진동음의 상태',
          is_checked: ''
        },
        {
          id: 11,
          label: '균열, 파손도 상태',
          is_checked: ''
        },
        {
          id: 12,
          label: '방전 시에 의한 소리의 상태',
          is_checked: ''
        },
        {
          id: 13,
          label: '볼트류의 조임',
          is_checked: ''
        },
        {
          id: 14,
          label: '방전 시 또는 과열에 의한 냄새상태',
          is_checked: ''
        },
        {
          id: 15,
          label: '케이블 막이판의 탈락 또는 간격의 벌어짐 상태',
          is_checked: ''
        },
        {
          id: 16,
          label: '포유류, 조류, 파충류 등 기타 침입의 흔적상태',
          is_checked: ''
        },
        {
          id: 17,
          label: '부대시설 변형 및 콘크리트 탈락 유무',
          is_checked: ''
        },
      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
